import Navbar from "../components/Navbar"
import AboutComponent from "../components/AboutComponent"
import Footer from "../components/Footer"
import SEOMetaTags from "../components/SEOMetaTags"

function About() {
  return (
    <div className="min-h-screen bg-white">
      <SEOMetaTags 
        title="Hakkımızda - Buğra Teknik Servis"
        description="2010 yılından beri Karabük'te hizmet veren Buğra Teknik Servis. 14+ yıl deneyim, 1000+ mutlu müşteri. Profesyonel teknik servis hizmetleri."
      />
      <Navbar />
      <div className="pt-16">
        <AboutComponent />
      </div>
      <Footer />
    </div>
  )
}

export default About
